module.exports = __webpack_public_path__ + "img/banner2.c26746c9.png";